"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmCloseModal = ConfirmCloseModal;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const components_1 = require("..");
const BeamContext_1 = require("../BeamContext");
/** Modal content to appear when a close checks fails */
function ConfirmCloseModal(props) {
    const { onClose, discardText = "Discard Changes", continueText = "Continue Editing" } = props;
    const { modalState } = (0, BeamContext_1.useBeamContext)();
    // TODO: Change to closeModal from useModal when canCloseChecks are reset
    function closeModal() {
        // Not using closeModal from useModal since the canClose checks are not reset
        // after a close and could/will cause other close attempts to fail.
        modalState.current = undefined;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.ModalHeader, { children: "Are you sure you want to cancel?" }), (0, jsx_runtime_1.jsx)(components_1.ModalBody, { children: (0, jsx_runtime_1.jsx)("p", { children: "Any changes you've made so far will be lost." }) }), (0, jsx_runtime_1.jsxs)(components_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(components_1.Button, { variant: "tertiary", label: discardText, onClick: () => {
                            // The order of these calls doesn't really matter; close this modal and tell the call to do their close
                            onClose();
                            closeModal();
                        } }), (0, jsx_runtime_1.jsx)(components_1.Button, { label: continueText, onClick: closeModal })] })] }));
}
